/* global axios */
import ApiClient from './ApiClient';

class QaDashboardApi extends ApiClient {
  constructor() {
    super('qa_dashboard', { accountScoped: true });
  }

  getTemplates() {
    return axios.get(`${this.url}/templates`);
  }

  createTemplate(payload) {
    return axios.post(`${this.url}/templates`, payload);
  }

  updateTemplate(templateId, payload) {
    return axios.patch(`${this.url}/templates/${templateId}`, payload);
  }

  deleteTemplate(templateId) {
    return axios.delete(`${this.url}/templates/${templateId}`);
  }

  getCloseTypeTemplates(locale) {
    return axios.get(`${this.url}/close_type_templates`, {
      params: { locale },
    });
  }

  updateCloseTypeTemplate(payload) {
    return axios.patch(`${this.url}/close_type_templates`, payload);
  }
}

export default new QaDashboardApi();
